import moment from "moment";
import { Endereco } from "./Endereco"
import { ItemEnum } from "./ItemEnum"
import { MBase } from "./MBase";

export class Pessoa extends MBase
{
    Id: number = 0;
    RazaoSocial: string = "";
    NomeFantasia: string = "";
    Tipo: EnumTipoPessoa = EnumTipoPessoa.Fisica;
    CpfCnpj: string = "";
    inscricaoEstadual: string = "";
    inscricaoMunicipal: string = "";
    Papel: EnumPapelPessoa;
    CpfResponsavel: string = "";
    NomeResponsavel: string = "";
    Telefone: string = "";
    Email: string = "";
    EmailAcesso: string = "";
    Ativo: Boolean = true
    Pix: string = "";
    Banco: string = "";
    Agencia: string = "";
    Conta: string = "";
    _bindLabel: string = "";
    Site: string = "";
    TipoFornecedor: string = "";
    ListaTipoFornecedor: EnumTipoFornecedor[] = [];
    TokenAcesso: string = "";
    // Endereço (campos diretos)
    Logradouro: string = "";
    Bairro: string = "";
    Cidade: string = "";
    Estado: string = "";
    Cep: string = "";
    Pais: string = "";

    // endereço (mantido para compatibilidade com código existente)
    Enderecos: Endereco[] = new Array<Endereco>();
    EnderecoCorrespondenciaIgualPrincipal: boolean = true;
    EnderecoEntregaIgualPrincipal: boolean = true;

    get dataAlteracaoStr(): string{
      return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
   }
    get descStatus(): string{
      if(this.Ativo && this.TokenAcesso){
        return 'Pendente'
      } else if(this.Ativo ){
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    }
}

export enum EnumTipoPessoa{
  Fisica = 1,
  Juridica = 2
}

export enum EnumTipoFornecedor
{
    Insumos = 1,
    Servicos = 2,
    Maquinas = 3,
    Transporte = 4,
    Tecnologias = 5,
    Logistica = 6,
}

export enum EnumPapelPessoa
{
    Fornecedor = 1,
    Cliente,
    Transportadora
}



export const ListaEnumTipoPessoa: ItemEnum[] = [
  {name: 'Pessoa Física', value: EnumTipoPessoa.Fisica},
  {name: 'Pessoa Jurídica', value: EnumTipoPessoa.Juridica},
]
export const ListaEnumTipoFornecedor: ItemEnum[] = [
  {name: 'Insumos', value: EnumTipoFornecedor.Insumos},
  {name: 'Serviços', value: EnumTipoFornecedor.Servicos},
  {name: 'Máquinas', value: EnumTipoFornecedor.Maquinas},
  {name: 'Transporte', value: EnumTipoFornecedor.Transporte},
  {name: 'Tecnologias', value: EnumTipoFornecedor.Tecnologias},
  {name: 'Logistica', value: EnumTipoFornecedor.Logistica},
]




